import { render } from "./IntercomBanner.vue?vue&type=template&id=a8251ed6&scoped=true"
import script from "./IntercomBanner.vue?vue&type=script&lang=js"
export * from "./IntercomBanner.vue?vue&type=script&lang=js"

import "./IntercomBanner.vue?vue&type=style&index=0&id=a8251ed6&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8251ed6"]])

export default __exports__